import { createTheme, responsiveFontSizes } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface TypographyVariants {
    label: React.CSSProperties;
    body: React.CSSProperties;
    passwordHint: React.CSSProperties;
    categoryLabel: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    label?: React.CSSProperties;
    body?: React.CSSProperties;
    passwordHint?: React.CSSProperties;
    categoryLabel?: React.CSSProperties;
  }

  interface Theme {
    custom: {
      footerHeight: number;
    };
  }
  interface ThemeOptions {
    custom?: {
      footerHeight?: number;
    };
  }
}

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    label: true;
    body: true;
    passwordHint: true;
    categoryLabel: true;
  }
}

const theme = createTheme({
  typography: {
    fontSize: 20,
    label: {
      fontSize: "0.875rem",
      fontWeight: 600,
    },
    body: {
      fontSize: "0.8125rem",
      fontWeight: 400,
    },
    passwordHint: {
      fontSize: "0.75rem",
      fontWeight: 400,
      lineHeight: 1.5,
      whiteSpace: "pre-line",
      display: "block",
    },
    categoryLabel: {
      fontSize: "0.875rem",
      lineHeight: "0.875rem",
      fontWeight: 400,
    },
  },
  palette: {
    primary: {
      main: "#375E97",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#3F681C",
      light: "#dbffed",
      contrastText: "#FFFFFF",
    },
    error: {
      main: "#FB6542",
      contrastText: "#fff",
      light: "#ffb6c1",
    },
    warning: {
      main: "#FFBB00",
      contrastText: "#000000",
    },
    background: {
      default: "#F0F0F0", // デフォルトの背景色を追加
    },
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          alignItems: "center",
        },
        standardInfo: {
          backgroundColor: "#E8F4FD",
          color: "#01579B",
        },
        standardSuccess: {
          backgroundColor: "#D4EDDA",
          color: "#155724",
        },
        standardError: {
          backgroundColor: "#F8D7DA",
          color: "#721C24",
        },
      },
    },
  },
});

export default responsiveFontSizes(theme);
